import { Box, Typography } from '@mui/material'
import { ReactNode } from 'react'

export const RowCard = ({
	children,
	onClick,
	testId,
}: {
	children: ReactNode
	onClick?: () => void
	testId?: string
}) => (
	<Box
		onClick={onClick}
		data-testid={testId}
		sx={{
			alignItems: 'center',
			border: '1px solid #ECECEC',
			borderRadius: '9px',
			cursor: onClick ? 'pointer' : 'default',
			display: 'flex',
			gap: 1.25,
			px: 1.75,
			py: 1.25,
			'&:hover': { bgcolor: '#FAFBFB', borderColor: '#DCE3E5' },
		}}
	>
		{children}
	</Box>
)

export const EmptyRow = ({ message }: { message: string }) => (
	<Box
		sx={{
			border: '1px dashed #E0E0E0',
			borderRadius: '9px',
			color: '#A8B4B8',
			p: 3,
			textAlign: 'center',
		}}
	>
		<Typography sx={{ fontSize: 12.5 }}>{message}</Typography>
	</Box>
)
